import axiosInstance from "./axiosInstance";

// Fetch all pre-releases for the current user (admin tracker)
// For admin: fetch all pre-releases with optional filters
export const fetchPreReleases = (page = 1, pageSize = 5, filters = {}) => {
    const params = { page, pageSize };

    // Add filters to params if provided
    if (filters.status) params.status = filters.status;
    if (filters.branch_id) params.branch_id = filters.branch_id;
    if (filters.user_id) params.user_id = filters.user_id;
    if (filters.dateFilter) params.dateFilter = filters.dateFilter;
    if (filters.startDate) params.startDate = filters.startDate;
    if (filters.endDate) params.endDate = filters.endDate;

    return axiosInstance.get('/admin/pre-releases', { params });
};

// Create a pre-release from the admin tracker
export const createPreRelease = (formData) => {
    return axiosInstance.post('/admin/pre-releases', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

// Approve a pre-release by ID
export const approvePreRelease = (id) => {
    return axiosInstance.patch(`/admin/pre-releases/${id}/approve`);
};

// Reject a pre-release by ID
export const rejectPreRelease = (id) => {
    return axiosInstance.patch(`/admin/pre-releases/${id}/reject`);
};
